const items = [
  "MOZ DA & PA API READY",
  "BULK SPAM SCORE DETECTION",
  "50 URLS PER BATCH",
  "SERP COMPETITION BENCHMARKING",
  "ONE-CLICK CSV EXPORT",
  "ZERO SIGNUP FRICTION",
];

export const Marquee = () => {
  const row = [...items, ...items];
  return (
    <div
      data-testid="editorial-marquee-band"
      className="relative overflow-hidden border-y border-[#263248] bg-[#121824] py-4"
    >
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span
            key={i}
            className="font-mono2 text-xs uppercase tracking-[0.25em] text-[#6B7280] px-8 flex items-center gap-8"
          >
            {item}
            <span className="text-[#D4FF00]">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
};
